import { PublicForm } from "../types/FormBuilderInterfaces";
import { Field, Module } from "../types/TenantInterfaces";
import Constants from "../utils/Constants";
import SubitemRenderer from "../components/Records/Subitems/SubitemRenderer";
import RequiredTitle from "../elements/RequiredTitle";
import { Col } from "reactstrap";
import InputFormatter from "../components/Records/Formatters/InputFormatter";

interface Props {
  form: PublicForm;
  field: string | { Field: Field };
  onChange: (field: any, value: any) => void;
  module?: Module;
  info: any;
  reset: any;
}

const FormField = ({ form, field, onChange, module, info, reset }: Props) => {
  const fieldData =
    form.Fields?.[
      typeof field === "string" ? field : field?.Field?.APIName || ""
    ];

  let fieldSchema = fieldData?.Field as Field;
  const fieldAPIName = fieldSchema?.APIName;
  const fieldSettings = fieldData?.Settings;
  const type = fieldSchema?.FieldType;

  const required = fieldSchema?.Required || fieldSettings?.Required;
  const defaultValue = fieldSettings?.Default;

  let Input;
  if (
    type === Constants.FIELDTYPES.MULTI_SUBITEM ||
    type === Constants.FIELDTYPES.SUBITEM
  ) {
    Input = (
      <SubitemRenderer
        key={fieldAPIName}
        module={module!}
        field={fieldSchema}
        prefill={undefined}
        handleChange={(_: any, value: any) => {
          onChange(fieldAPIName, value);
        }}
        subItemValues={info?.[fieldAPIName] ?? []}
        defaultSub={undefined}
        disableReadonlyFields={true}
        publicForm={true}
      />
    );
  } else {
    Input = (
      //@ts-ignore
      <InputFormatter
        key={field + reset}
        module={{ APIName: form.ModuleAPIName } as Module}
        field={fieldSchema}
        value={info?.[fieldAPIName] || defaultValue}
        //@ts-ignore
        onChange={(_, value: any) => {
          onChange(fieldAPIName, value);
        }}
        //@ts-ignore
        placeholder={fieldSettings?.Placeholder}
      />
    );
  }

  return (
    <Col
      xs="12"
      sm="12"
      md={
        type === Constants.FIELDTYPES.MULTI_SUBITEM ||
        type === Constants.FIELDTYPES.SUBITEM
          ? "12"
          : form?.FieldStyles?.FieldsPerRow === "1"
          ? "12"
          : "6"
      }
      className="mb-4"
    >
      {required ? (
        <RequiredTitle
          title={fieldSettings?.Label}
          titleStyle={{
            color: form?.FieldStyles?.LabelsColor ?? "var(--dark)",
          }}
        />
      ) : (
        <h4
          className={`text-sm font-weight-600`}
          style={{
            color: form?.FieldStyles?.LabelsColor ?? "var(--dark)",
            marginBottom: 6,
          }}
        >
          {fieldSettings?.Label}
        </h4>
      )}
      {Input}
    </Col>
  );
};

export default FormField;
